document.addEventListener("DOMContentLoaded", function () {
  // Get the button (anchor tag) element
  const popupButton = document.querySelector(
    "fieldset.product-form__input .form__label a.popup_button"
  );

  // Get the seats popup wrapper element
  const seatsPopupWrapper = document.querySelector(".seats_popup_wrapper");

  // Add a click event listener to the popup button
  if (popupButton && seatsPopupWrapper) {
    popupButton.addEventListener("click", function (event) {
      // Prevent default link behavior
      event.preventDefault();

      // Add the 'active' class to the seats_popup_wrapper
      seatsPopupWrapper.classList.add("active");
    });
  }
  $(".seats_popup_wrapper .popup_header .popup_header_icon").on(
    "click",
    function () {
      $(".seats_popup_wrapper").removeClass("active");
    }
  );

  // Swatch Label Load
  // Function to create the span dynamically
  function createOrUpdateSpan(value) {
      const labelElement = document.querySelector('.product-form__input-color .form__label');
      if (labelElement) {
          let span = labelElement.querySelector('span.dynamic-value');
          if (!span) {
              // If span doesn't exist, create it
              span = document.createElement('span');
              span.className = 'dynamic-value'; // Add a class to the span
              labelElement.appendChild(span); // Append the span to the label
          }
          span.textContent = value; // Update the span content
      }
 
    
  }

    function createOrUpdateSpan2(value) {
 
    const labelElement2 = document.querySelector('.product-form__input.coverage .form__label');
      if (labelElement2) {
          let span = labelElement2.querySelector('span.dynamic-value');
          if (!span) {
              // If span doesn't exist, create it
              span = document.createElement('span');
              span.className = 'dynamic-value'; // Add a class to the span
              labelElement2.appendChild(span); // Append the span to the label
          }
          span.textContent = value; // Update the span content
      }
      document.getElementById("productCoverage").value = value;
    
  }

  function createOrUpdateSpan3(value) {
 
    const labelElement2 = document.querySelector('.product-form__input.product-form__input-pattern .form__label');
      if (labelElement2) {
          let span = labelElement2.querySelector('span.dynamic-value');
          if (!span) {
              // If span doesn't exist, create it
              span = document.createElement('span');
              span.className = 'dynamic-value'; // Add a class to the span
              labelElement2.appendChild(span); // Append the span to the label
          }
          span.textContent = value; // Update the span content
      }
      document.getElementById("productCoverage").value = value;
    
  }

  

  // Function to update span based on the checked input on window load
  function updateSpanOnLoad() {
      const checkedInput = document.querySelector('.product-form__input-color input[type="radio"]:checked');
      if (checkedInput) {
          const value = checkedInput.value; // Get the value from the checked input
          createOrUpdateSpan(value); // Update or create the span with the value
      }

    const checkedInput2 = document.querySelector('.product-form__input.coverage input[type="radio"]:checked');
      if (checkedInput2) {
          const value = checkedInput2.value; // Get the value from the checked input
          createOrUpdateSpan2(value); // Update or create the span with the value
         
      }

    const checkedInput3 = document.querySelector('.product-form__input.product-form__input-pattern input[type="radio"]:checked');
      if (checkedInput2) {
          const value = checkedInput2.value; // Get the value from the checked input
          createOrUpdateSpan3(value); // Update or create the span with the value
         
      }
    
  }

  // Add click events to swatches
  document.querySelectorAll('.product-form__input-color .swatch-color').forEach((swatch) => {
      swatch.addEventListener('mousedown', (event) => event.preventDefault());
      swatch.addEventListener('click', function () {
          const dataTitle = swatch.getAttribute('data-title'); // Get the data-title attribute value
          if (dataTitle) {
              createOrUpdateSpan(dataTitle); // Update or create the span with the data-title
          }
      });
  });

  document.querySelectorAll('.product-form__input.coverage label').forEach((swatch) => {
      swatch.addEventListener('mousedown', (event) => event.preventDefault());
      swatch.addEventListener('click', function () {
          const dataTitle = swatch.getAttribute('data-title'); // Get the data-title attribute value
          if (dataTitle) {
              createOrUpdateSpan2(dataTitle); // Update or create the span with the data-title
          }
      });
  });

  document.querySelectorAll('.product-form__input.product-form__input-pattern label').forEach((swatch) => {
      swatch.addEventListener('mousedown', (event) => event.preventDefault());
      swatch.addEventListener('click', function () {
          const dataTitle = swatch.getAttribute('data-title'); // Get the data-title attribute value
          if (dataTitle) {
              createOrUpdateSpan3(dataTitle); // Update or create the span with the data-title
          }
      });
  });

  // Run the update function on window load
  updateSpanOnLoad();
});

